import { render, staticRenderFns } from "./Quotation-Table.vue?vue&type=template&id=7c712560&scoped=true"
import script from "./Quotation-Table.vue?vue&type=script&lang=js"
export * from "./Quotation-Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c712560",
  null
  
)

export default component.exports